var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4791 1.98278C17.4963 0.236273 20.0195 0.236269 21.0367 1.98277L25.2739 9.25755C25.6465 9.89733 26.2709 10.351 26.9946 10.5077L35.2226 12.2895C37.198 12.7172 37.9777 15.1168 36.631 16.624L31.0216 22.9018C30.5283 23.4539 30.2898 24.188 30.3644 24.9246L31.2125 33.3006C31.4161 35.3114 29.3748 36.7945 27.5253 35.9795L19.8213 32.5846C19.1438 32.286 18.372 32.286 17.6945 32.5846L9.99052 35.9795C8.14098 36.7945 6.09974 35.3114 6.30334 33.3006L7.1514 24.9246C7.22598 24.188 6.98747 23.4539 6.49416 22.9018L0.884796 16.624C-0.461883 15.1168 0.317798 12.7172 2.29317 12.2895L10.5213 10.5077C11.2449 10.351 11.8693 9.89733 12.2419 9.25755L16.4791 1.98278Z",
    fill: "#CBC5BF",
    fillOpacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty-star.58234f52089c5f30a28dfd4b806ca8be.svg";
export { ForwardRef as ReactComponent };